import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentsDataService {
  private _paymentSuccessful: BehaviorSubject<boolean>;
  private _orderId: BehaviorSubject<string>;
  private _paymentId: BehaviorSubject<string>;
  private _paymentMethod: BehaviorSubject<string>;

  constructor() {
    this._paymentSuccessful = new BehaviorSubject<boolean>(false);
    this._orderId = new BehaviorSubject<string>(null);
    this._paymentId = new BehaviorSubject<string>(null);
    this._paymentMethod = new BehaviorSubject<string>(null);
  }

  // getter methods
  public get isPaymentSuccessful(): BehaviorSubject<boolean> {
    return this._paymentSuccessful;
  }

  public get receiptOrderId(): BehaviorSubject<string> {
    return this._orderId;
  }

  public get receiptPaymentId(): BehaviorSubject<string> {
    return this._paymentId;
  }

  public get paymentMethod(): BehaviorSubject<string> {
    return this._paymentMethod;
  }

  // set methods

  public setPaymentSuccessful(value: boolean): void {
    this._paymentSuccessful.next(value);
  }

  public setOrderId(value: string): void {
    this._orderId.next(value);
  }

  public setPaymentId(value: string): void {
    this._paymentId.next(value);
  }

  public setPaymentMethod(value: string): void {
    this._paymentMethod.next(value);
  }
}
